/**
 * Flycher analytics — self-hosted only.
 * Every event is sent to /api/events/track on the Flycher backend.
 * The custom admin dashboard at /admin reads from this pipeline.
 */

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

let ready = false;
let anonId = "";
let sessionId = "";

function getAnonId() {
  if (anonId) return anonId;
  try {
    let id = localStorage.getItem("fl_anon_id");
    if (!id) {
      id =
        (crypto.randomUUID && crypto.randomUUID()) ||
        `a-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem("fl_anon_id", id);
    }
    anonId = id;
  } catch {
    anonId = `a-${Date.now()}`;
  }
  return anonId;
}

function getSessionId() {
  if (sessionId) return sessionId;
  try {
    const fresh = `s-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const last = sessionStorage.getItem("fl_session_id");
    sessionId = last || fresh;
    if (!last) sessionStorage.setItem("fl_session_id", fresh);
  } catch {
    sessionId = `s-${Date.now()}`;
  }
  return sessionId;
}

function postToBackend(event, props) {
  if (!BACKEND) return;
  const body = JSON.stringify({
    event,
    props: props || {},
    anon_id: getAnonId(),
    session_id: getSessionId(),
    path: typeof window !== "undefined" ? window.location.pathname : "",
    referrer: typeof document !== "undefined" ? document.referrer : "",
  });
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(`${BACKEND}/api/events/track`, blob);
      return;
    }
    fetch(`${BACKEND}/api/events/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    /* never break the app for an analytics failure */
  }
}

export function initAnalytics() {
  if (ready || typeof window === "undefined") return;
  ready = true;
  getAnonId();
  getSessionId();
}

export function track(event, props = {}) {
  postToBackend(event, props);
}

export function trackPageView(path) {
  postToBackend("$pageview", { path });
}
